import React, { useState } from "react";
import Webcam from "react-webcam-barcode-scanner";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./BarcodeScannerButton.scss";

const BarcodeScannerButton = ({ handleResult }) => {
  const [showModal, setShowModal] = useState(false);
  const [qrData, setQrData] = useState("");

  const handleScan = (err, result) => {
    if (result) {
      const { text, format } = result;
      setQrData(text);
      handleResult(text);
      toggleModal();
    }
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <i
        className="bx bx-camera me-2 text-info icon-camera"
        onClick={toggleModal}
        title="Quét Barcode"
        style={{
          position: "absolute",
          cursor: "pointer",
          right: "11px",
          fontSize: "21px",
          background: "white",
          border: "1px solid #556ee6",
          padding: "4px",
          borderRadius: "19px",
        }}
      ></i>
      <Modal isOpen={showModal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Quét Barcode</ModalHeader>
        <ModalBody>
          <div style={{ width: "100%" }}>
            <Webcam width={"100%"} onUpdate={handleScan} />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggleModal}>
            Đóng
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default BarcodeScannerButton;
